import { render, staticRenderFns } from "./CalciatoreSuTavolo.vue?vue&type=template&id=0a9bd0ec&scoped=true&"
import script from "./CalciatoreSuTavolo.vue?vue&type=script&lang=js&"
export * from "./CalciatoreSuTavolo.vue?vue&type=script&lang=js&"
import style0 from "./CalciatoreSuTavolo.vue?vue&type=style&index=0&id=0a9bd0ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9bd0ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a9bd0ec')) {
      api.createRecord('0a9bd0ec', component.options)
    } else {
      api.reload('0a9bd0ec', component.options)
    }
    module.hot.accept("./CalciatoreSuTavolo.vue?vue&type=template&id=0a9bd0ec&scoped=true&", function () {
      api.rerender('0a9bd0ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/CalciatoreSuTavolo.vue"
export default component.exports